import { render, staticRenderFns } from "./aiSelect.vue?vue&type=template&id=e4c4cc70&scoped=true&"
import script from "./aiSelect.vue?vue&type=script&lang=js&"
export * from "./aiSelect.vue?vue&type=script&lang=js&"
import style0 from "./aiSelect.vue?vue&type=style&index=0&id=e4c4cc70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c4cc70",
  null
  
)

export default component.exports